export default {
    computed: {
        sidebar() {
            return this.$store.state.app.sidebar;
        },

        classObj() {
            return {
                hideSidebar: !this.sidebar.opened,
                openSidebar: this.sidebar.opened,
                withoutAnimation: this.sidebar.withoutAnimation
            };
        }
    }
};


// WEBPACK FOOTER //
// ./src/assets/mixins/SidebarComputed.js